// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"BadgesTable_badgeWrapper__INjw5"};